var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./addExhibitorsBrand.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-46f62576!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./addExhibitorsBrand.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/staging/addExhibitorsBrand.vue
// module id = 1561
// module chunks = 3